const subscribers = {};

function subscribe(event, callback) {
  (subscribers[event] = subscribers[event] || []).push(callback);
  return () => {
    subscribers[event] = subscribers[event].filter((cb) => cb !== callback);
  };
}

function publish(event, data) {
  (subscribers[event] || []).forEach((cb) => cb(data));
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

window.MX = { subscribe, publish, fetchConfig };

document.addEventListener('click', (event) => {
  document.querySelectorAll('details[open][data-close-outside]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const details = event.target.closest('details[open]');
  if (details) {
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.focus();
  }
});

const headerEl = document.querySelector('.header');
if (headerEl && 'ResizeObserver' in window) {
  new ResizeObserver(() => {
    document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
  }).observe(headerEl);
}

if (headerEl && headerEl.classList.contains('header--sticky')) {
  let scrollQueued = false;
  window.addEventListener(
    'scroll',
    () => {
      if (scrollQueued) return;
      scrollQueued = true;
      requestAnimationFrame(() => {
        scrollQueued = false;
        if (window.scrollY > 120) headerEl.classList.add('header--compact');
        else if (window.scrollY < 40) headerEl.classList.remove('header--compact');
      });
    },
    { passive: true }
  );
}

document.querySelectorAll('details.menu-drawer').forEach((drawer) => {
  drawer.addEventListener('toggle', () => {
    document.documentElement.classList.toggle('scroll-lock', drawer.open);
  });
});

class QuantityInput extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input');
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button || !this.input) return;
      event.preventDefault();
      if (button.name === 'plus') this.input.stepUp();
      else this.input.stepDown();
      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
}
customElements.define('quantity-input', QuantityInput);

class SearchToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.header-search__toggle');
    if (!this.button) return;

    this.button.addEventListener('click', () => this.toggle());

    this.onDocClick = (event) => {
      if (this.hasAttribute('open') && !this.contains(event.target)) this.close();
    };
    this.onKey = (event) => {
      if (event.key === 'Escape' && this.hasAttribute('open')) {
        this.close();
        this.button.focus();
      }
    };
    document.addEventListener('click', this.onDocClick);
    document.addEventListener('keydown', this.onKey);
  }

  toggle() {
    if (this.hasAttribute('open')) {
      this.close();
    } else {
      this.setAttribute('open', '');
      this.button.setAttribute('aria-expanded', 'true');
      const input = this.querySelector('input');
      if (input) input.focus();
    }
  }

  close() {
    this.removeAttribute('open');
    this.button.setAttribute('aria-expanded', 'false');
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocClick);
    document.removeEventListener('keydown', this.onKey);
  }
}
customElements.define('search-toggle', SearchToggle);

class CartCount extends HTMLElement {
  connectedCallback() {
    this.unsubscribe = subscribe('cart:update', (cart) => {
      this.textContent = cart.item_count;
      this.toggleAttribute('data-empty', cart.item_count === 0);
    });
  }
  disconnectedCallback() {
    if (this.unsubscribe) this.unsubscribe();
  }
}
customElements.define('cart-count', CartCount);

class DeferredMedia extends HTMLElement {
  connectedCallback() {
    const trigger = this.querySelector('button');
    if (trigger) trigger.addEventListener('click', () => this.load(), { once: true });
  }
  load() {
    const template = this.querySelector('template');
    if (!template) return;
    this.replaceChildren(template.content.cloneNode(true));
    this.setAttribute('loaded', '');
    const video = this.querySelector('video');
    if (video && video.play) video.play();
  }
}
customElements.define('deferred-media', DeferredMedia);

const SHINE_SELECTOR = '.button, .evm-ws__cart-submit';

if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  let shineTarget = null;
  let shineX = 0;
  let shineY = 0;
  let shineQueued = false;

  const paintShine = () => {
    shineQueued = false;
    if (!shineTarget) return;
    const rect = shineTarget.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    shineTarget.style.setProperty('--btn-shine-x', `${((shineX - rect.left) / rect.width) * 100}%`);
    shineTarget.style.setProperty('--btn-shine-y', `${((shineY - rect.top) / rect.height) * 100}%`);
  };

  document.addEventListener(
    'pointermove',
    (event) => {
      const button = event.target.closest && event.target.closest(SHINE_SELECTOR);
      shineTarget = button;
      if (!button) return;
      shineX = event.clientX;
      shineY = event.clientY;
      if (shineQueued) return;
      shineQueued = true;
      requestAnimationFrame(paintShine);
    },
    { passive: true }
  );
}

document.querySelectorAll('.mega__content--railed').forEach((content) => {
  const rail = content.querySelector('[data-mega-rail]');
  const panels = content.querySelectorAll('[data-mega-panel]');
  if (!rail || panels.length < 2) return;

  const tabs = rail.querySelectorAll('[data-mega-tab]');
  const wrap = content.closest('.mega__wrap');
  const asideLink = wrap ? wrap.querySelector('[data-mega-aside-link]') : null;

  const show = (slug) => {
    let active = null;
    panels.forEach((panel) => {
      const on = panel.dataset.megaPanel === slug;
      panel.hidden = !on;
      panel.classList.toggle('is-active', on);
      if (on) active = panel;
    });
    tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.megaTab === slug));

    if (asideLink) {
      const label = (active && active.dataset.asideLabel) || asideLink.dataset.defaultLabel;
      const url = (active && active.dataset.asideUrl) || asideLink.dataset.defaultUrl;
      const text = asideLink.querySelector('span');
      if (text && label) text.textContent = label;
      if (url) asideLink.setAttribute('href', url);
    }
  };

  tabs.forEach((tab) => {
    tab.addEventListener('mouseenter', () => show(tab.dataset.megaTab));
    tab.addEventListener('focus', () => show(tab.dataset.megaTab));
  });
});

// Any element can opt into the Help Scout widget with data-beacon-open. The Beacon itself
// is loaded by the Help Scout app embed, not the theme. Anchors keep a real href so the
// click still goes somewhere if the Beacon never loads (ad blockers, no Beacon ID set on
// the app embed, network failure) rather than dying silently.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-beacon-open]');
  if (!trigger) return;

  // Beacon absent — leave the click alone so the href still works.
  if (typeof window.Beacon !== 'function') return;

  event.preventDefault();
  window.Beacon('open');
});

// Support status. Help Scout does not expose agent availability to the storefront, so
// the published office hours stand in for it. Done here rather than in Liquid because
// the page is edge-cached: a render-time timestamp would freeze and go stale within
// the hour, which is how the header came to read "Live Chat Offline" around the clock.
// Markup renders closed and this only ever upgrades it, so a thrown Intl call or a bad
// timezone leaves the shopper with "email us" instead of a promise nobody answers.
const SHORT_DAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

document.querySelectorAll('[data-support-hours]').forEach((root) => {
  const start = parseInt(root.dataset.start, 10);
  const end = parseInt(root.dataset.end, 10);
  const days = (root.dataset.days || '').split(',').map((d) => parseInt(d, 10));
  if (Number.isNaN(start) || Number.isNaN(end)) return;

  let parts;
  try {
    parts = new Intl.DateTimeFormat('en-US', {
      timeZone: root.dataset.tz || 'America/Los_Angeles',
      weekday: 'short',
      hour: 'numeric',
      hour12: false,
    }).formatToParts(new Date());
  } catch (e) {
    return; // unusable timezone — stay closed
  }

  const weekday = parts.find((p) => p.type === 'weekday');
  const hourPart = parts.find((p) => p.type === 'hour');
  if (!weekday || !hourPart) return;

  const day = SHORT_DAYS[weekday.value];
  // hour12:false renders midnight as 24 in some engines.
  const hour = parseInt(hourPart.value, 10) % 24;
  if (day === undefined || Number.isNaN(hour)) return;
  if (!days.includes(day) || hour < start || hour >= end) return;

  root.classList.add('is-open');
  root.querySelectorAll('[data-support-text]').forEach((el) => {
    if (el.dataset.openLabel) el.textContent = el.dataset.openLabel;
  });
});
